// extracted by mini-css-extract-plugin
module.exports = {"inputError":"InputError_inputError__ePtF9","scale":"InputError_scale__7rBU3"};